module.exports = __webpack_public_path__ + "img/pay2.4bbdaf0f.png";